import { render, staticRenderFns } from "./StudentListO.vue?vue&type=template&id=6ff5f79b&"
import script from "./StudentListO.vue?vue&type=script&lang=js&"
export * from "./StudentListO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports